// utils/cookieConsent.js
export const getCookieConsent = () => {
  const consent = localStorage.getItem('cookie-consent');
  return consent ? JSON.parse(consent) : null;
};

export const hasAnalyticsConsent = () => {
  const consent = getCookieConsent();
  return consent && consent.analytics === true;
};

export const hasMarketingConsent = () => {
  const consent = getCookieConsent();
  return consent && consent.marketing === true;
};

// Prüfe ob Matomo-Script wirklich im DOM geladen ist
const isMatomoScriptLoaded = () => {
  if (typeof document === 'undefined') return false;
  const scripts = document.getElementsByTagName('script');
  for (let i = 0; i < scripts.length; i++) {
    if (scripts[i].src && scripts[i].src.includes('matomo.js')) {
      return true;
    }
  }
  return false;
};

// Lade Matomo Analytics nur nach Einwilligung
export const loadMatomo = () => {
  // Prüfe ob Matomo-Script wirklich geladen ist, nicht nur ob _paq existiert
  if (isMatomoScriptLoaded()) {
    // Matomo ist bereits geladen
    return;
  }

  // Wenn _paq existiert aber Script nicht geladen ist, reset _paq
  if (window._paq && !isMatomoScriptLoaded()) {
    window._paq = [];
  }

  window._paq = window._paq || [];
  window._paq.push(['trackPageView']);
  window._paq.push(['enableLinkTracking']);
  
  (function() {
    var u = "//matomo.carriera-ai.com/";
    window._paq.push(['setTrackerUrl', u + 'matomo.php']);
    window._paq.push(['setSiteId', '2']);
    var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
    g.async = true;
    g.src = u + 'matomo.js';
    s.parentNode.insertBefore(g, s);
  })();
};

// Lade lfeeder Tracking nur nach Einwilligung
export const loadLfeeder = () => {
  if (window.ldfdr) {
    // lfeeder ist bereits geladen
    return;
  }

  (function(ss, ex) {
    window.ldfdr = window.ldfdr || function() {
      (window.ldfdr._q = window.ldfdr._q || []).push([].slice.call(arguments));
    };
    (function(d, s) {
      var fs = d.getElementsByTagName(s)[0];
      function ce(src) {
        var cs = d.createElement(s);
        cs.src = src;
        cs.async = 1;
        fs.parentNode.insertBefore(cs, fs);
      }
      ce('https://sc.lfeeder.com/lftracker_v1_' + ss + (ex ? '_' + ex : '') + '.js');
    })(document, 'script');
  })('JMvZ8gny2QMa2pOd');
};

// Initialisiere Tracking-Scripts basierend auf Consent
export const initializeTrackingScripts = () => {
  const consent = getCookieConsent();
  
  if (!consent) {
    return; // Kein Consent, keine Scripts laden
  }

  // Analytics Scripts laden
  if (consent.analytics) {
    loadMatomo();
  }

  // Marketing Scripts laden
  if (consent.marketing) {
    loadLfeeder();
  }

  // Google Analytics (falls vorhanden)
  if (consent.analytics && typeof window.gtag !== 'undefined') {
    window.gtag('consent', 'update', {
      'analytics_storage': 'granted'
    });
  }
};

// Entferne Tracking-Scripts (bei Widerruf)
export const removeTrackingScripts = () => {
  // Matomo entfernen - entferne auch das Script aus dem DOM
  if (window._paq) {
    window._paq = [];
  }
  
  // Entferne Matomo-Script aus DOM falls vorhanden
  if (typeof document !== 'undefined') {
    const scripts = document.getElementsByTagName('script');
    for (let i = scripts.length - 1; i >= 0; i--) {
      if (scripts[i].src && scripts[i].src.includes('matomo.js')) {
        scripts[i].parentNode.removeChild(scripts[i]);
      }
    }
  }
  
  // lfeeder entfernen
  if (window.ldfdr) {
    window.ldfdr = function() {};
  }
};

// Aktualisiere Tracking-Scripts basierend auf neuen Consent-Einstellungen
export const updateTrackingScripts = (consent) => {
  if (!consent) {
    removeTrackingScripts();
    return;
  }

  // Analytics Scripts
  if (consent.analytics) {
    loadMatomo();
  } else {
    // Matomo deaktivieren und Script entfernen
    if (window._paq) {
      window._paq = [];
    }
    // Entferne Matomo-Script aus DOM falls vorhanden
    if (typeof document !== 'undefined') {
      const scripts = document.getElementsByTagName('script');
      for (let i = scripts.length - 1; i >= 0; i--) {
        if (scripts[i].src && scripts[i].src.includes('matomo.js')) {
          scripts[i].parentNode.removeChild(scripts[i]);
        }
      }
    }
  }

  // Marketing Scripts
  if (consent.marketing) {
    loadLfeeder();
  } else {
    // lfeeder deaktivieren
    if (window.ldfdr) {
      window.ldfdr = function() {};
    }
  }

  // Google Analytics (falls vorhanden)
  if (consent.analytics && typeof window.gtag !== 'undefined') {
    window.gtag('consent', 'update', {
      'analytics_storage': 'granted'
    });
  } else if (typeof window.gtag !== 'undefined') {
    window.gtag('consent', 'update', {
      'analytics_storage': 'denied'
    });
  }
};

// Event Listener für Consent Changes
export const onConsentChange = (callback) => {
  window.addEventListener('storage', (e) => {
    if (e.key === 'cookie-consent') {
      callback(getCookieConsent());
    }
  });
  
  // Auch auf lokale Änderungen reagieren (wenn im gleichen Tab geändert)
  const originalSetItem = localStorage.setItem;
  localStorage.setItem = function(key, value) {
    originalSetItem.apply(this, arguments);
    if (key === 'cookie-consent') {
      const event = new Event('storage');
      event.key = key;
      event.newValue = value;
      window.dispatchEvent(event);
    }
  };
};